import { GeneralModel } from './general.model';

export class Introduce extends GeneralModel{
    id: number;
    code: string;
    name: string;
    createdWhen: any;
    concurrencyStamp: string;
    subTitle: string;
    icon: string;
    imagePath: any;
    content: string;
    totalCount: number;
    orderNumber: number;
}
